<template>
  <div class="tags-wrapper h-100">
    <template v-if="loading">
      <div class="loading">
        <GjIcon name="Loader" />
      </div>
    </template>
    <form-wrapper
      v-else
      header
    >

      <template v-slot:header>
        <p class="text">
          Enter a key and, optionally, a value. You can add up to 10 tags. Valid characters include a-z, A-Z, 0-9, space, and the special characters _ - . : / = + @.
        </p>
      </template>

      <template v-slot:body>
        <template v-if="tags.length > 0 && loaded">
          <div class="d-flex offset-md-3">
            <div class="d-flex w-100">
              <div class="w-50">
                Key
              </div>
              <div class="w-50">
                Value
              </div>
            </div>
          </div>

          <div
            v-for="tag in tags"
            :key="tag.index"
            class="d-flex offset-md-3 align-items-center"
          >
            <div class="d-flex w-100">
              <b-form-input
                v-model="tag.key"
                placeholder="Add unique key..."
              />
              <b-form-input
                v-model="tag.value"
                placeholder="Add value..."
              />
            </div>
            <a
              v-show="tag.index !== lastIndex"
              class="link"
              @click="onRemoveField(tag.index)"
            ><GjIcon name="Close" />
            </a>
            <a
              v-show="tag.index === lastIndex"
              class="link"
              @click="onAddField"
            ><GjIcon name="Plus" /></a>
          </div>
        </template>
      </template>

      <template v-slot:footer>
        <b-button
          variant="bg-white"
          @click="onCancel()"
        >
          Cancel
        </b-button>
        <b-button
          variant="bg-primary"
          class="ml-16"
          @click="onSave"
        >
          Save
        </b-button>
      </template>

    </form-wrapper>
  </div>
</template>
<script>
export default {
  name: 'TagsForm',
  props: {
    tag: {
      default: null,
      type: Object,
    },
  },
  data() {
    return {
      distributionId: null,
      tags: [],
      loaded: false,
      deletedTags: [],
      tagsDeleted: false,
      tagsAdded: false,
      continue: false,
      loading: true,
    }
  },
  computed: {
    lastIndex() {
      return this.tags.length > 0 ? this.tags[this.tags.length - 1].index : 0
    },
    distributionTags() {
      return this.$store.state.cdn.tags
    },
  },
  created() {
    this.distributionId = this.$route.params.id
    this.$store.dispatch('cdn/fetchTags', this.distributionId)
      .then(() => {
        this.loading = false
        this.fillTags()
      })
      .catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while fetching tags.') })
  },
  methods: {
    onAddField() {
      this.tags.push(
        {
          index: this.lastIndex + 1,
          key: '',
          value: '',
        },
      )
    },
    onRemoveField(index) {
      const deleted = this.tags.find(obj => obj.index === index)
      if (deleted.id) {
        this.deletedTags.push(deleted.id)
      }

      this.tags = this.tags.filter(obj => obj.index !== index)
      for (let i = 0; i < this.tags.length; i++) {
        this.tags[i].index = i
      }
    },
    onSave() {
      this.$store.commit('app/TOGGLE_OVERLAY', true)
      for (let i = 0; i < this.deletedTags.length; i++) {
        this.$store.dispatch('cdn/removeTag', {
          distributionId: this.$route.params.id,
          id: this.deletedTags[i],
        }).then(() => {
          this.tagsDeleted = true
          this.tagsDone()
        }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while removing tag.') })
      }

      for (let i = 0; i < this.tags.length; i++) {
        const tag = this.tags[i]
        if (i === this.tags.length - 1) {
          this.continue = true
        }
        if (!tag.id && tag.key !== '' && tag.value !== '') {
          this.continue = false
          this.$store.dispatch('cdn/addTag', {
            distributionId: this.$route.params.id,
            id: tag.index,
            key: tag.key,
            value: tag.value,
          }).then(() => {
            this.tagsAdded = true
            this.tagsDone()
          }).catch(error => { this.errorToast(error.response?.data?.errors[0] || 'Something went wrong while creating tag.') })
        }
      }
    },

    wentWrong(error) {
      this.errorToast(error)
      this.$store.commit('app/TOGGLE_OVERLAY', false)
    },

    tagsDone() {
      if ((this.tagsDeleted || this.deletedTags.length === 0) && (this.tagsDeleted || this.continue)) {
        this.$store.commit('app/TOGGLE_OVERLAY', false)
        this.$emit('close')
        this.onCancel()
      }
    },

    onCancel() {
      this.$router.push({ name: 'distribution-tags', params: { id: this.distributionId } })
    },

    fillTags() {
      if (this.distributionTags.length > 0) {
        this.distributionTags.forEach(element => {
          this.tags.push(
            {
              id: element.id,
              index: this.lastIndex + 1,
              key: element.key,
              value: element.value,
            },
          )
        })
        this.tags.push(
          {
            index: this.lastIndex + 1,
            key: '',
            value: '',
          },
        )
        this.loaded = true
      } else {
        this.tags = [
          {
            index: 0,
            key: '',
            value: '',
          },
          {
            index: 1,
            key: '',
            value: '',
          },
        ]
        this.loaded = true
      }
    },
  },
}
</script>
